import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';  
import { dateFormat, endpoint, endpointApi } from '../../utils';
import { getInvoices } from '../../redux/actions/invoice.action';
import SearchOrder from '../../components/SearchOrder';
import SearchClient from '../../components/SearchClient';
import OrderItem from '../../components/OrderItem';
import Paginate from '../../components/Paginate';
import { setLoading } from '../../redux/actions/loader.action';
import axios from 'axios';
import { logout } from '../../redux/actions/auth.action';

export default function InvoicesPage() {
  const jwt_access = localStorage.getItem('jwt_access');
  const invoices = useSelector(state => state.invoices);
  const { me } = useSelector(state => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const addModalRef = useRef(null);
  const detailsModalRef = useRef(null);
  const updateModalRef = useRef(null);
  const noteModalRef = useRef(null);
  const addNoteModalRef = useRef(null);
  const addFormRef = useRef(null);
  const updateFormRef = useRef(null);
  const [modal, setModal] = useState(null);
  const [actionModal, setActionModal] = useState(null);

  const [invoice, setInvoice] = useState(null);
  const [code, setCode] = useState("");
  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([{key: 0}]);
  const [orderDate, setOrderDate] = useState("");
  const [purchaseOrder, setPurchaseOrder] = useState("");
  const [client, setClient] = useState(null);
  const [status, setStatus] = useState("");
  
  const [commentDate, setCommentDate] = useState("");
  const [commentContent, setCommentContent] = useState("");
  
  const [isCommentDateTouched, setIsCommentDateTouched] = useState(false);
  const [isCommentContentTouched, setIsCommentContentTouched] = useState(false);

  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [withdrawalFeesViaMvola, setWithdrawalFeesViaMvola] = useState("");
  const [delivryFees, setDelivryFees] = useState("");
  const [shippingFees, setShippingFees] = useState("");
  const [discount, setDiscount] = useState(0.00);
  const [invoiceStatus, setInvoiceStatus] = useState("");

  const [isCodeTouched, setIsCodeTouched] = useState(false);
  const [isInvoiceDateTouched, setIsInvoiceDateTouched] = useState(false);
  const [isInvoiceStatusTouched, setIsInvoiceStatusTouched] = useState(false);
  const [isOrderDateTouched, setIsOrderDateTouched] = useState(false);
  const [isDiscountTouched, setIsDiscountTouched] = useState(false);
  const [isPurchaseOrderTouched, setIsPurchaseOrderTouched] = useState(false);
  const [isStatusTouched, setIsStatusTouched] = useState(false);

  const [isNewOrder, setIsNewOrder] = useState(false);

  const [key, setKey] = useState(1);
  const [errors, setErrors] = useState(null);
  const [subtotal, setSubtotal] = useState(null);

  useEffect(() => {
    dispatch(getInvoices(location, navigate));
  }, [location, navigate, dispatch]);

  const addItem = () => {
    setItems([...items, {key: key + 1}]);
    setKey(key + 1);
  }

  const removeItem = (key) => {
    if(items.length > 1)
      setItems(items.filter(item => item.key !== key));
  }
  
  useEffect(() => {
    if(isNewOrder){
      setOrder(null);
    }else{
      setClient(null);
      setOrderDate("");
      setPurchaseOrder("");
      setStatus("");
      setIsOrderDateTouched(false);
      setIsPurchaseOrderTouched(false);
      setIsStatusTouched(false);
    }
  }, [isNewOrder]);

  useEffect(() => {
    if(modal !== 'update'){
      if(addFormRef.current)
        addFormRef.current.reset();

      if(modal === null && updateFormRef.current)
        updateFormRef.current.reset();

      setItems([{key: 1}]);
      setInvoiceDate("");
      setInvoiceDueDate("");
      setInvoiceStatus("");
      setIsInvoiceDateTouched(false);
      setIsInvoiceStatusTouched(false);
      setOrder(null);
      setClient(null);
      setOrderDate("");
      setPurchaseOrder("");
      setStatus("");
      
      setWithdrawalFeesViaMvola("");
      setDelivryFees("");
      setShippingFees("");
      setDiscount(0.00);

      setCommentDate("");
      setCommentContent("");

      setIsCommentDateTouched(false);
      setIsCommentContentTouched(false);

      setIsOrderDateTouched(false);
      setIsPurchaseOrderTouched(false);
      setIsStatusTouched(false);
      setIsDiscountTouched(false);

      setErrors(null);
    }
  }, [modal]);

  useEffect(() => {
    if(modal === 'update' && invoice){
      setCode(invoice.code);
      setInvoiceDate(invoice.date);
      setInvoiceDueDate(invoice.due_date ? invoice.due_date : '');
      setInvoiceStatus(invoice.status);
      setWithdrawalFeesViaMvola(invoice.withdrawal_fees_via_mvola ? invoice.withdrawal_fees_via_mvola : '');
      setDelivryFees(invoice.delivry_fees ? invoice.delivry_fees : '');
      setShippingFees(invoice.shipping_fees ? invoice.shipping_fees : '');
      setDiscount(invoice.discount ? invoice.discount : 0.00);
    }
  }, [modal, invoice]);

  useEffect(() => {
    if(modal === 'details' && invoice){
      const st = invoice.items.reduce((acc, item) => { return acc + item.quantity * item.unit_price; }, 0);
      setSubtotal(st);
    }else{
      setSubtotal(null);
    }
  }, [modal, invoice]);

  useEffect(() => {
    const clickModalOutside = (e) => {
      if((addModalRef.current && addModalRef.current === e.target && addModalRef.current.classList.contains('active')) || (noteModalRef.current && noteModalRef.current === e.target && noteModalRef.current.classList.contains('active'))  || (addNoteModalRef.current && addNoteModalRef.current === e.target && addNoteModalRef.current.classList.contains('active'))  || (detailsModalRef.current && detailsModalRef.current === e.target && detailsModalRef.current.classList.contains('active'))  || (updateModalRef.current && updateModalRef.current === e.target && updateModalRef.current.classList.contains('active')) || e.target.classList.contains('_modal-close')){
        setModal(null);
      }
    }
    document.addEventListener('click', clickModalOutside);
    return () => {
      document.removeEventListener('click', clickModalOutside);
    }
  }, []);

  useEffect(() => {
    const clickOutsideActionModal = (e) => {
      const $actionModals = document.querySelectorAll('.actions>ul');
      $actionModals.forEach($actionModal => {
        if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
          setActionModal(null);
        }
      });
    }
    document.addEventListener('click', clickOutsideActionModal);
    return () => {
      document.removeEventListener('click', clickOutsideActionModal);
    }
  }, []);

  useEffect(() => {
    if(modal){
      const $modals = document.querySelectorAll('._modal-content');
      $modals.forEach($modal => {
        $modal.scrollTop = 0;
      })
    }
  }, [modal]);

  const handleSubmit = async(e) => {
    e.preventDefault();
    setErrors(null);
    dispatch(setLoading(false));
    const data = new FormData(e.target);
    await axios.post(`${ endpointApi }invoices`, data, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${ jwt_access }`          
                }
              })
              .then(({ data }) => {
                dispatch(getInvoices(location, navigate));
                setInvoice(data);
                setModal("details");
              })
              .catch(err => {
                if(err.response.status === 401){
                  dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
              })
              .finally(() => {
                dispatch(setLoading(false));
              });
  }
  
  const handleSubmitUpdate = async(e) => {
    e.preventDefault();
    setErrors(null);
    dispatch(setLoading(false));
    const data = new FormData(e.target);
    await axios.put(`${ endpointApi }invoices/${ invoice?.id }`, data, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${ jwt_access }`          
                }
              })
              .then(({ data }) => {
                dispatch(getInvoices(location, navigate));
                setInvoice(data);
                setModal("details");
              })
              .catch(err => {
                if(err.response.status === 401){
                  dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
              })
              .finally(() => {
                dispatch(setLoading(false));
              });
  }
  
  const handleSubmitAddComment = async(e) => {
    e.preventDefault();
    setErrors(null);
    dispatch(setLoading(false));
    const data = new FormData(e.target);
    await axios.post(`${ endpointApi }invoices/${ invoice?.id }/comment`, data, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${ jwt_access }`          
                }
              })
              .then(({ data }) => {
                dispatch(getInvoices(location, navigate));
                setInvoice(data);
                setModal("note");
              })
              .catch(err => {
                if(err.response.status === 401){
                  dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
              })
              .finally(() => {
                dispatch(setLoading(false));
              });
  }

  const f_eval = (val) => {
    return eval(val);
  }

  useEffect(() => {
    if(!jwt_access){
      navigate('/login?redirect_to=' + location.pathname + location.search);
    }
  }, [location, navigate, jwt_access]);

  return (
    me &&
    <HelmetProvider>
      <Helmet>
        <title>Factures - Société Mikalo</title>
      </Helmet>

      <Header />

      <Nav />

      <main id='main'>
        <div className='title d-flex justify-content-between'>
          <h1>Factures</h1>
          <button type='button' onClick={ () => {
            setModal('add');
          } } className='btn btn-primary'><i className='fa fa-plus'></i> Créer</button>
        </div>
        
        <div ref={ addModalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
          <div className='_modal-content'>
            <div className='_modal-head'>
              <h4>Créer une facture</h4>
              <button className='_modal-close' onClick={ () => {
                setModal(null);
              }}>&times;</button>
            </div>
            <div className='_modal-body'>
              <form ref={ addFormRef } className='form' onSubmit={ handleSubmit }>
                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                <h6>Commande</h6>
                <div className='mb-3'>
                  <label>
                    <input type='checkbox' name='is_new_order' value={ isNewOrder } onChange={ (e) => setIsNewOrder(e.target.checked) } />
                    <div></div>
                    Nouvelle commande
                  </label>
                </div>

                { isNewOrder ? <>
                  <div className='mb-3'>
                    <label htmlFor='order_date' className='required'>Date de commande</label>
                    <input type='date' name='order_date' id='order_date' required className='form-control' value={ orderDate } onChange={ (e) => setOrderDate(e.target.value) } onBlur={ () => setIsOrderDateTouched(true) } />
                    { isOrderDateTouched && orderDate.length === 0 && <div className='form-error'>Veuillez saisir la date de la commande.</div> }
                    { errors && errors.order_date && <div className='form-error'>{ errors.order_date[0] }</div> }
                  </div>
                  
                  <div className='mb-3'>
                    <label htmlFor='purchase_order'>N° de bon de commande</label>
                    <input type='text' name='purchase_order' id='purchase_order' placeholder='N° de bon de commande' className='form-control' value={ purchaseOrder } onChange={ (e) => setPurchaseOrder(e.target.value) } onBlur={ () => setIsPurchaseOrderTouched(true) } />
                    { isPurchaseOrderTouched && purchaseOrder.length > 0 && purchaseOrder.length < 2 && <div className='form-error'>Le numéro de bon de commande est trop court. Veuillez saisir au moins 2 caractères.</div> }
                    { errors && errors.purchase_order && <div className='form-error'>{ errors.purchase_order[0] }</div> }
                  </div>
                  
                  <div className='mb-3'>
                    <label htmlFor='client_id' className='required'>Client</label>
                    <input type='hidden' name='client_id' className='form-control' value={ client ? client.id : "" } />
                    <SearchClient updateClient={ setClient } required={ true } reset={ modal !== "add" || isNewOrder === true } defaultValue={ client } />
                    { errors && errors.client_id && <div className='form-error'>{ errors.client_id[0] }</div> }
                  </div>

                  { items.map((item, index) => {
                    return(
                      <OrderItem item={ index } reset={ modal !== "add" || isNewOrder === true } itemKey={ item.key } key={ item.key } onRemove={ removeItem } errors={ errors } />
                    )
                  }) }
                  
                  <div className='mb-3 text-end'>
                    <button type='button' onClick={ addItem } className='btn btn-sm btn-info'><i className='fa fa-plus'></i> Ajouter un produit</button>
                  </div>

                  <div className='mb-3'>
                    <label htmlFor='status' className='required'>Etat de la commande</label>
                    <select id='status' name='status' required className='form-control' value={ status } onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                      <option value="">Sélectionner...</option>
                      <option value="Pending">En attente</option>
                      <option value="Confirmed">Confirmée</option>
                      <option value="Shipped">Expédiée</option>
                      <option value="Delivered">Livrée</option>
                      <option value="Cancelled">Annulée</option>
                      <option value="Returned">Retournée</option>
                    </select>
                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la commande.</div> }
                    { errors && errors.status && <div className='form-error'>{ errors.status[0] }</div> }
                  </div>
                </> : 
                <div className='mb-3'>
                  <label htmlFor='order_id' className='required'>N° de commande</label>
                  <input type='hidden' name='order_id' className='form-control' value={ order ? order.id : "" } />
                  <SearchOrder updateOrder={ setOrder } defaultValue={ order } />
                  { errors && errors.order_id && <div className='form-error'>{ errors.order_id[0] }</div> }
                </div> }

                <h6>Facture</h6>
                <div className='mb-3'>
                  <label htmlFor='invoice_date' className='required'>Date de la facture</label>
                  <input type='date' id='invoice_date' name='invoice_date' required className='form-control' value={ invoiceDate } onChange={ (e) => setInvoiceDate(e.target.value) } onBlur={ () => setIsInvoiceDateTouched(true) } />
                  { isInvoiceDateTouched && invoiceDate.length === 0 && <div className='form-error'>Veuillez saisir la date de la facture.</div> }
                  { errors && errors.invoice_date && <div className='form-error'>{ errors.invoice_date[0] }</div> }
                </div>
                
                <div className='mb-3'>
                  <label htmlFor='invoice_due_date'>Date d'échéance de la facture</label>
                  <input type='date' id='invoice_due_date' name='invoice_due_date' className='form-control' value={ invoiceDueDate } onChange={ (e) => setInvoiceDueDate(e.target.value) } />
                  { errors && errors.invoice_due_date && <div className='form-error'>{ errors.invoice_due_date[0] }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='withdrawal_fees_via_mvola'>Frais de retrait via mvola</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='withdrawal_fees_via_mvola' name='withdrawal_fees_via_mvola' placeholder='Frais de retrait via mvola' className='form-control' value={ withdrawalFeesViaMvola } onChange={ (e) => setWithdrawalFeesViaMvola(e.target.value) } />
                  { errors && errors.withdrawal_fees_via_mvola && <div className='form-error'>{ errors.withdrawal_fees_via_mvola[0] }</div> }
                </div>
                  
                <div className='mb-3'>
                  <label htmlFor='delivry_fees'>Frais de livraison</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='delivry_fees' name='delivry_fees' placeholder='Frais de livraison' className='form-control' value={ delivryFees } onChange={ (e) => setDelivryFees(e.target.value) } />
                  { errors && errors.delivry_fees && <div className='form-error'>{ errors.delivry_fees[0] }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='shipping_fees'>Frais d'envoi</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='shipping_fees' name='shipping_fees' placeholder="Frais d'envoi" className='form-control' value={ shippingFees } onChange={ (e) => setShippingFees(e.target.value) } />
                  { errors && errors.shipping_fees && <div className='form-error'>{ errors.shipping_fees[0] }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='discount'>Remise (en %)</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='discount' name='discount' placeholder="Remise (en %)" className='form-control' value={ discount } onChange={ (e) => setDiscount(e.target.value) } onBlur={ () => setIsDiscountTouched(true) } />
                  { isDiscountTouched && discount.length === 0 && <div className='form-error'>Ce champ ne peut pas être vide.</div> }
                  { errors && errors.discount && <div className='form-error'>{ errors.discount[0] }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='invoice_status' className='required'>Etat de la facture</label>
                  <select id='invoice_status' name='invoice_status' required className='form-control' value={ invoiceStatus } onChange={ (e) => setInvoiceStatus(e.target.value) } onBlur={ () => setIsInvoiceStatusTouched(true) }>
                    <option value="">Sélectionner...</option>
                    <option value="Pending">En attente</option>
                    <option value="Sent">Envoyée</option>
                    <option value="Paid">Payée</option>
                    <option value="Overdue">En retard</option>
                    <option value="Cancelled">Annulée</option>
                    <option value="Refunded">Remboursée</option>
                  </select>
                  { isInvoiceStatusTouched && invoiceStatus.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la facture.</div> }
                  { errors && errors.invoice_status && <div className='form-error'>{ errors.invoice_status[0] }</div> }
                </div>

                <div className='pt-2 text-end'>
                  <button type='submit' disabled={
                    (isNewOrder === false && order === null) ||
                    (isNewOrder === true && (orderDate.length === 0 || client === null || status.length === 0)) ||
                    invoiceDate.length === 0 || invoiceStatus.length === 0 || 
                    items.length === 0
                  } className='btn btn-lg btn-primary'><i className="fa fa-save"></i> Enregistrer</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div ref={ detailsModalRef } className={ `_modal${ modal === "details" && invoice ? ' active' : '' }` }>
          <div className='_modal-content'>
            <div className='_modal-head'>
              { invoice && 
              <h4>Facture N° { invoice.code }</h4> }
              <button type='button' className='_modal-close'>&times;</button>
            </div>
            <div className='_modal-body'>
              { invoice && <>
                <div className='row'>
                  <div className='col-6 mb-3'>
                    <div className='_label'>Code</div>
                    <div className='_value'>{ invoice.code }</div>
                  </div>

                  <div className='col-6 mb-3'>
                    <div className='_label'>Date de facture</div>
                    <div className='_value'>{ dateFormat(invoice.date) }</div>
                  </div>
                </div>

                <div className='mb-3'>
                  <div className='_label'>Date d'échéance de la facture</div>
                  <div className='_value'>{ invoice.due_date ? dateFormat(invoice.due_date) : '-'}</div>
                </div>

                <div className='mb-3'>
                  <div className='_label'>Client</div>
                  <div className='_value'>
                    { invoice.order && invoice.order.client ? (invoice.order.client.type === "Company" ? invoice.order.client.company_name : invoice.order.client.last_name + " " + invoice.order.client.first_name) : '-' }
                    <br/>
                    { invoice.order.client ? invoice.order.client.address + ", " + invoice.order.client.zipcode + " " + invoice.order.client.city + ", " + invoice.order.client.country : "-" }
                    <br/>
                    { invoice.order.client ? (invoice.order.client.email ? "E-mail: " : "") + invoice.order.client.email + (invoice.order.client.phone ? (invoice.order.client.email ? " - Tél: " : "Tél: ") + invoice.order.client.phone : "") + (invoice.order.client.website ? (invoice.order.client.email || invoice.order.client.phone ? " - Site web: " : "Site web: ") + invoice.order.client.website : "") : "-" }
                  </div>
                </div>

                <div className='row'>
                  <div className='col-6 mb-3'>
                    <div className='_label'>Montant</div>
                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval(invoice.order.total_amount + '+' + invoice.withdrawal_fees_via_mvola + '+' + invoice.delivry_fees + '+' + invoice.shipping_fees)) } Ariary</div>
                  </div>

                  <div className='col-6 mb-3'>
                    <div className='_label'>Etat</div>
                    <div className='_value'>{ invoice.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (invoice.status === "Paid" ? <span className="badge bg-success">Payée</span> : (invoice.status === "Overdue" ? <span className="badge bg-danger">En retard</span> : (invoice.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : (invoice.status === "Refunded" ? <span className="badge bg-danger">Remboursée</span> : <span className="badge bg-warning">En attente</span> ))))}</div>
                  </div>
                </div>

                <div className='mb-3'>
                  <div className='_label'>Détails{ invoice && invoice.order ? ' (Commande N° ' + invoice.order.code + ')' : '' }</div>
                  <div className='_value'>
                    <table className='table table-striped'>
                      <thead>
                        <tr>
                          <th>Produit</th>
                          <th>Quantité</th>
                          <th>Prix unit. (Ariary)</th>
                          <th>Montant HT (Ariary)</th>
                        </tr>
                      </thead>
                      <tbody>
                        { invoice && invoice.items.map((item, index) => {
                          const lineTotal = item.quantity * item.unit_price;
                          return(
                            <tr key={ index }>
                              <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                              <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                              <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price) }</td>
                              <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(lineTotal) }</td>
                            </tr>
                          )
                        }) }
                        { invoice.withdrawal_fees_via_mvola &&
                        <tr>
                          <td colSpan={ 3 }>Frais de retrait via mvola</td>
                          <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.withdrawal_fees_via_mvola) }</td>
                        </tr> }
                        { invoice.delivry_fees &&
                        <tr>
                          <td colSpan={ 3 }>Frais de livraison</td>
                          <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.delivry_fees) }</td>
                        </tr> }
                        { invoice.shipping_fees &&
                        <tr>
                          <td colSpan={ 3 }>Frais d'envoi</td>
                          <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.shipping_fees) }</td>
                        </tr> }
                        <tr>
                          <th colSpan={ 3 }>Sous-total</th>
                          <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(subtotal) }</th>
                        </tr>
                        { invoice.discount && invoice.discount > 0 &&
                        <tr>
                            <th colSpan={ 3 }>Remise ({ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.discount) }%)</th>
                            <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(subtotal * invoice.discount / 100) }</th>
                        </tr> }
                        <tr>
                          <th colSpan={ 3 } className='text-uppercase'>Total</th>
                          <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(subtotal + invoice.withdrawal_fees_via_mvola + invoice.delivry_fees + invoice.shipping_fees - (subtotal * invoice.discount / 100)) }</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className='text-center pt-2'>
                  <a href={ `${ endpoint }invoice/${ invoice.id }/download` } target='_blank' rel="noreferrer" className='btn btn-lg btn-orange me-3' onClick={ () => setModal("edit") }><i className='fa fa-download'></i> Télécharger</a>
                  <button type='button' className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className='fa fa-edit'></i> Modifier</button>
                </div>
              </> }
            </div>
          </div>
        </div>
        
        <div ref={ updateModalRef } className={ `_modal${ modal === "update" && invoice ? ' active' : '' }` }>
          <div className='_modal-content'>
            <div className='_modal-head'>
              { invoice &&
              <h4>Modifier la facture N° { invoice.code }</h4> }
              <button type='button' className='_modal-close'>&times;</button>
            </div>
            <div className='_modal-body'>
              <form ref={ updateFormRef } className='form' onSubmit={ handleSubmitUpdate }>
                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                <div className='mb-3'>
                  <label htmlFor='code' className='required'>Code</label>
                  <input type='text' name='code' id='code' placeholder='Code facture' className='form-control' value={ code } onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                  { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code facture.</div> }
                  { isCodeTouched && code.length > 0 && /^FAC\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code facture n'est pas valide. Le format valide est: FAC/[année]/[numéro d'ordre].</div> }
                  { errors && errors.code && <div className='form-error'>{ errors.code }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='_invoice_date' className='required'>Date de la facture</label>
                  <input type='date' id='_invoice_date' name='invoice_date' required className='form-control' value={ invoiceDate } onChange={ (e) => setInvoiceDate(e.target.value) } onBlur={ () => setIsInvoiceDateTouched(true) } />
                  { isInvoiceDateTouched && invoiceDate.length === 0 && <div className='form-error'>Veuillez saisir la date de la facture.</div> }
                  { errors && errors.invoice_date && <div className='form-error'>{ errors.invoice_date }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='_invoice_due_date'>Date d'échéance de la facture</label>
                  <input type='date' id='_invoice_due_date' name='invoice_due_date' className='form-control' value={ invoiceDueDate } onChange={ (e) => setInvoiceDueDate(e.target.value) } />
                  { errors && errors.invoice_due_date && <div className='form-error'>{ errors.invoice_due_date[0] }</div> }
                </div>

                <div className='mb-3'>
                  <div className='_label'>Client</div>
                  <div className='_value'>
                    { invoice && invoice.order && invoice.order.client ? (invoice.order.client.type === "Company" ? invoice.order.client.company_name : invoice.order.client.last_name + " " + invoice.order.client.first_name) : '-' }
                    <br/>
                    { invoice && invoice.order && invoice.order.client ? invoice.order.client.address + ", " + invoice.order.client.zipcode + " " + invoice.order.client.city + ", " + invoice.order.client.country : "-" }
                    <br/>
                    { invoice && invoice.order && invoice.order.client ? (invoice.order.client.email ? "E-mail: " : "") + invoice.order.client.email + (invoice.order.client.phone ? (invoice.order.client.email ? " - Tél: " : "Tél: ") + invoice.order.client.phone : "") + (invoice.order.client.website ? (invoice.order.client.email || invoice.order.client.phone ? " - Site web: " : "Site web: ") + invoice.order.client.website : "") : "-" }
                  </div>
                </div>
                
                <div className='mb-3'>
                  <div className='_label'>Détails{ invoice && invoice.order ? ' (Commande N° ' + invoice.order.code + ')' : '' }</div>
                  <div className='_value'>
                    <table className='table table-striped'>
                      <thead>
                        <tr>
                          <th>Produit</th>
                          <th>Quantité</th>
                          <th>Prix unit. (Ariary)</th>
                          <th>Montant HT (Ariary)</th>
                        </tr>
                      </thead>
                      <tbody>
                        { invoice && invoice.items.map((item, index) => {
                          return(
                          <tr key={ index }>
                            <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                            <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                            <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price) }</td>
                            <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price * item.quantity) }</td>
                          </tr>
                          )
                        }) }
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className='mb-3'>
                  <label htmlFor='_withdrawal_fees_via_mvola'>Frais de retrait via mvola</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='_withdrawal_fees_via_mvola' name='withdrawal_fees_via_mvola' placeholder='Frais de retrait via mvola' className='form-control' value={ withdrawalFeesViaMvola } onChange={ (e) => setWithdrawalFeesViaMvola(e.target.value) } />
                  { errors && errors.withdrawal_fees_via_mvola && <div className='form-error'>{ errors.withdrawal_fees_via_mvola[0] }</div> }
                </div>
                  
                <div className='mb-3'>
                  <label htmlFor='_delivry_fees'>Frais de livraison</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='_delivry_fees' name='delivry_fees' placeholder='Frais de livraison' className='form-control' value={ delivryFees } onChange={ (e) => setDelivryFees(e.target.value) } />
                  { errors && errors.delivry_fees && <div className='form-error'>{ errors.delivry_fees[0] }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='_shipping_fees'>Frais d'envoi</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='_shipping_fees' name='shipping_fees' placeholder="Frais d'envoi" className='form-control' value={ shippingFees } onChange={ (e) => setShippingFees(e.target.value) } />
                  { errors && errors.shipping_fees && <div className='form-error'>{ errors.shipping_fees[0] }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='_discount'>Remise (en %)</label>
                  <input type='number' min={ 0 } step={ 0.01 } id='_discount' name='discount' placeholder="Remise (en %)" className='form-control' value={ discount } onChange={ (e) => setDiscount(e.target.value) } onBlur={ () => setIsDiscountTouched(true) } />
                  { isDiscountTouched && discount.length === 0 && <div className='form-error'>Ce champ ne peut pas être vide.</div> }
                  { errors && errors.discount && <div className='form-error'>{ errors.discount[0] }</div> }
                </div>

                <div className='mb-3'>
                  <label htmlFor='_invoice_status' className='required'>Etat de la facture</label>
                  <select id='_invoice_status' name='invoice_status' required className='form-control' value={ invoiceStatus } onChange={ (e) => setInvoiceStatus(e.target.value) } onBlur={ () => setIsInvoiceStatusTouched(true) }>
                    <option value="">Sélectionner...</option>
                    <option value="Pending">En attente</option>
                    <option value="Sent">Envoyée</option>
                    <option value="Paid">Payée</option>
                    <option value="Overdue">En retard</option>
                    <option value="Cancelled">Annulée</option>
                    <option value="Refunded">Remboursée</option>
                  </select>
                  { isInvoiceStatusTouched && invoiceStatus.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la facture.</div> }
                  { errors && errors.invoice_status && <div className='form-error'>{ errors.invoice_status }</div> }
                </div>

                <div className='pt-2 text-end'>
                  <button type='submit' disabled={
                    code.length === 0 || invoiceDate.length === 0 || invoiceStatus.length === 0 ||
                    (modal === 'update' && invoice && invoice.date === invoiceDate && invoice.status === invoiceStatus && ((invoice.withdrawal_fees_via_mvola === null && withdrawalFeesViaMvola.length === 0) || (invoice.withdrawal_fees_via_mvola !== null && invoice.withdrawal_fees_via_mvola === withdrawalFeesViaMvola)) && ((invoice.delivry_fees === null && delivryFees.length === 0) || (invoice.delivry_fees !== null && invoice.delivry_fees === delivryFees)) && ((invoice.shipping_fees === null && shippingFees.length === 0) || (invoice.shipping_fees !== null && invoice.shipping_fees === shippingFees)))
                  } className='btn btn-lg btn-primary'><i className="fa fa-save"></i> Mettre à jour</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div ref={ noteModalRef } className={ `_modal${ modal === 'note' && invoice ? ' active' : '' }` }>
          <div className='_modal-content'>
            <div className='_modal-head'>
              { invoice &&
              <h4>Notes: Facture N° { invoice.code }</h4> }
              <button type='button' className='_modal-close' onClick={ () => setModal(null) }>&times;</button>
            </div>
            <div className='_modal-body'>
            { invoice && <>
              <div className='row'>
                  <div className='col-6 mb-3'>
                    <div className='_label'>Code</div>
                    <div className='_value'>{ invoice.code }</div>
                  </div>

                  <div className='col-6 mb-3'>
                    <div className='_label'>Date de facture</div>
                    <div className='_value'>{ dateFormat(invoice.date) }</div>
                  </div>
                </div>

                <div className='mb-3'>
                  <div className='_label'>Date d'échéance de la facture</div>
                  <div className='_value'>{ dateFormat(invoice.due_date) }</div>
                </div>

                <div className='mb-3'>
                  <div className='_label'>Client</div>
                  <div className='_value'>
                    { invoice.order && invoice.order.client ? (invoice.order.client.type === "Company" ? invoice.order.client.company_name : invoice.order.client.last_name + " " + invoice.order.client.first_name) : '-' }
                    <br/>
                    { invoice.order.client ? invoice.order.client.address + ", " + invoice.order.client.zipcode + " " + invoice.order.client.city + ", " + invoice.order.client.country : "-" }
                    <br/>
                    { invoice.order.client ? (invoice.order.client.email ? "E-mail: " : "") + invoice.order.client.email + (invoice.order.client.phone ? (invoice.order.client.email ? " - Tél: " : "Tél: ") + invoice.order.client.phone : "") + (invoice.order.client.website ? (invoice.order.client.email || invoice.order.client.phone ? " - Site web: " : "Site web: ") + invoice.order.client.website : "") : "-" }
                  </div>
                </div>

                <div className='row'>
                  <div className='col-6 mb-3'>
                    <div className='_label'>Montant</div>
                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.order.total_amount) } Ariary</div>
                  </div>

                  <div className='col-6 mb-3'>
                    <div className='_label'>Etat</div>
                    <div className='_value'>{ invoice.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (invoice.status === "Paid" ? <span className="badge bg-success">Payée</span> : (invoice.status === "Overdue" ? <span className="badge bg-danger">En retard</span> : (invoice.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : (invoice.status === "Refunded" ? <span className="badge bg-danger">Remboursée</span> : <span className="badge bg-warning">En attente</span> ))))}</div>
                  </div>
                </div>

                <h6>Notes</h6>
                <table className='table'>
                  <thead>
                    <tr>
                        <th width="140">Date</th>
                        <th>Commentaire</th>
                    </tr>
                  </thead>
                  <tbody>
                    { invoice && invoice.notes.length === 0 && 
                    <tr>
                      <td colSpan={ 2 }>Aucun commentaire</td>
                    </tr> }
                    { invoice && invoice.notes.map((item, index) => {
                      return(
                        <tr key={ index }>
                            <td>{ dateFormat(item.date) }</td>
                            <td>{ item.comment }</td>
                        </tr>
                      )
                    }) }
                  </tbody>
                </table>
                <div className='pt-3 text-center'>
                  <button type='button' className='btn btn-lg btn-primary' onClick={ () => setModal('addNote') }><i className='fa fa-plus'></i> Ajouter un commentaire</button>
                </div>
              </> }
            </div>
          </div>
        </div>

        <div ref={ addNoteModalRef } className={ `_modal${ modal === "addNote" && invoice ? ' active' : '' }` }>
          <div className='_modal-content'>
            <div className='_modal-head'>
              { invoice &&
              <h4>Ajouter un commentaire Facture N° { invoice.code }</h4> }
              <button type='button' className='_modal-close' onClick={ () => setModal(null) }>&times;</button>
            </div>
            <div className='_modal-body'>
              { invoice && <>
                <div className='row'>
                  <div className='col-6 mb-3'>
                    <div className='_label'>Code</div>
                    <div className='_value'>{ invoice.code }</div>
                  </div>

                  <div className='col-6 mb-3'>
                    <div className='_label'>Date de facture</div>
                    <div className='_value'>{ dateFormat(invoice.date) }</div>
                  </div>
                </div>

                <div className='mb-3'>
                  <div className='_label'>Date d'échéance de la facture</div>
                  <div className='_value'>{ dateFormat(invoice.due_date) }</div>
                </div>

                <div className='mb-3'>
                  <div className='_label'>Client</div>
                  <div className='_value'>
                    { invoice.order && invoice.order.client ? (invoice.order.client.type === "Company" ? invoice.order.client.company_name : invoice.order.client.last_name + " " + invoice.order.client.first_name) : '-' }
                    <br/>
                    { invoice.order.client ? invoice.order.client.address + ", " + invoice.order.client.zipcode + " " + invoice.order.client.city + ", " + invoice.order.client.country : "-" }
                    <br/>
                    { invoice.order.client ? (invoice.order.client.email ? "E-mail: " : "") + invoice.order.client.email + (invoice.order.client.phone ? (invoice.order.client.email ? " - Tél: " : "Tél: ") + invoice.order.client.phone : "") + (invoice.order.client.website ? (invoice.order.client.email || invoice.order.client.phone ? " - Site web: " : "Site web: ") + invoice.order.client.website : "") : "-" }
                  </div>
                </div>

                <div className='row'>
                  <div className='col-6 mb-3'>
                    <div className='_label'>Montant</div>
                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.order.total_amount) } Ariary</div>
                  </div>

                  <div className='col-6 mb-3'>
                    <div className='_label'>Etat</div>
                    <div className='_value'>{ invoice.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (invoice.status === "Paid" ? <span className="badge bg-success">Payée</span> : (invoice.status === "Overdue" ? <span className="badge bg-danger">En retard</span> : (invoice.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : (invoice.status === "Refunded" ? <span className="badge bg-danger">Remboursée</span> : <span className="badge bg-warning">En attente</span> ))))}</div>
                  </div>
                </div>

                <form className='form' onSubmit={ handleSubmitAddComment }>
                  <h6>Nouveau commentaire</h6>
                  <div className='mb-3'>
                    <label htmlFor='commentDate' className='required'>Date</label>
                    <input type="date" id="commentDate" name="date" className='form-control' required onChange={ (e) => setCommentDate(e.target.value) } onBlur={ () => setIsCommentDateTouched(true) } />
                    { isCommentDateTouched && commentDate.length === 0 && <div className='form-error'>Veuillez sélectionner la date.</div> }
                    { errors && errors.date && <div className='form-error'>{ errors.date }</div> }
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='commentContent' className='required'>Commentaire</label>
                    <textarea id="commentContent" name="comment" className='form-control' placeholder='Commentaire' maxLength={ 255 } required value={ commentContent } onChange={ (e) => setCommentContent(e.target.value) } onBlur={ () => setIsCommentContentTouched(true) } />
                    { isCommentContentTouched && commentContent.length === 0 && <div className='form-error'>Veuillez saisir un commentaire.</div> }
                    { isCommentContentTouched && commentContent.length > 0 && commentContent.length < 10 && <div className='form-error'>Le commenttaire est trop court. Veuillez saisir au moins 10 caractères.</div> }
                    { errors && errors.comment && <div className='form-error'>{ errors.comment }</div> }
                  </div>
                  <div className='pt-2 text-center'>
                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                      commentDate.length === 0 || commentContent.length < 10
                    }><i className='fa fa-save'></i> Enregistrer</button>
                  </div>
                </form>
              </> }
            </div>
          </div>
        </div>

        <div className='box'>
          <table className='table table-striped'>
            <thead>
              <tr>
                <th width="100">Code</th>
                <th width="100">Date</th>
                <th width="100">Echéance</th>
                <th>Client</th>
                <th>Montant</th>
                <th width="160" className="text-center">Notes</th>
                <th width="120">Statut</th>
                <th width="75" className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              { invoices.loading && <tr><td colSpan={ 8 }>Chargement...</td></tr> }
              { invoices.loading === false && invoices.data && invoices.data.total === 0 && <tr><td colSpan={ 8 }>Aucun élément trouvé</td></tr> }
              { invoices.loading === false && invoices.data && invoices.data.data && invoices.data.data.map((item, index) => {
              return (
              <tr key={ index }>
                <td>{ item.code }</td>
                <td>{ dateFormat(item.date) }</td>
                <td>{ item.due_date ? dateFormat(item.due_date) : '' }</td>
                <td>{ item.order && item.order.client ? (item.order.client.type === 'Company' ? item.order.client.company_name : item.order.client.last_name + " " + item.order.client.first_name) : 'Non renseigné' }</td>
                <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval(item.order.total_amount + '+' + item.withdrawal_fees_via_mvola + '+' + item.delivry_fees + '+' + item.shipping_fees)) } Ariary</td>
                <td className="text-center"><button type="button" className='btn_link' onClick={ () => {
                  setInvoice(item);
                  setModal("note");
                }}><i className='fa fa-comment'></i> { item.notes.length } commentaire{ item.notes.length > 1 ? 's' : '' }</button></td>
                <td>
                  { item.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (item.status === "Paid" ? <span className="badge bg-success">Payée</span> : (item.status === "Overdue" ? <span className="badge bg-danger">En retard</span> : (item.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : (item.status === "Refunded" ? <span className="badge bg-danger">Remboursée</span> : <span className="badge bg-warning">En attente</span> ))))}
                </td>
                <td className="text-end">
                  <div className='actions'>
                    <button type='button' className='toggle-action' onClick={ (e) => {
                      e.stopPropagation();
                      setActionModal(actionModal !== item.id ? item.id : null);
                    } }><i className='fa fa-ellipsis-v'></i></button>
                    <ul className={ actionModal === item.id ? 'active' : '' }>
                      <li><button type='button' onClick={ () => {
                        setActionModal(null);
                        setModal("details");
                        setInvoice(item);
                      } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                      <li><a href={ `${ endpoint }invoice/${ item.id }/download` } target='_blank' rel="noreferrer" onClick={ () => {
                        setActionModal(null);
                      } }><i className="fa fa-download"></i> Télécharger</a></li>
                      <li><button type='button' onClick={ () => {
                        setActionModal(null);
                        setModal("update");
                        setInvoice(item);
                      } }><i className="fa fa-edit"></i> Modifier</button></li>
                    </ul>
                  </div>
                </td>
              </tr> ) })}
            </tbody>
          </table>
        </div>
        
        { invoices && invoices.data &&
        <Paginate currentPage={ invoices.data.current_page } totalPages={ invoices.data.last_page } pathname={ location.pathname } search={ location.search } /> }
      </main>
    </HelmetProvider>
  )
}
